import { all } from 'redux-saga/effects';
import Auth from './Auth';
import Places from './Places';
import Users from './Users';

export default function* rootSaga(getState) {
    yield all([Auth(), Places(), Users()]);
}
